exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".gJnBB{margin-bottom:6px}._16pBf{display:block;box-sizing:border-box;margin:0;padding:20px 16px;width:100%;outline:0;border:1px solid #373277;border-radius:4px;background:#373277;color:#fff;text-align:center;text-decoration:none;font-size:16px;line-height:1.3333333;cursor:pointer}._16pBf:hover{background:rgba(54,50,119,.8)}._16pBf:focus{border-color:#0074c2;box-shadow:0 0 8px rgba(0,116,194,.6)}.wWDRT{border-color:#3b5998;background:#3b5998;border-radius:4px;text-decoration:none}.wWDRT:focus,.wWDRT:hover{background:#2d4373;color:#fff;text-decoration:none}._1K08m{border-color:#dd4b39;background:#dd4b39;border-radius:4px;text-decoration:none}._1K08m:focus,._1K08m:hover{background:#c23321;color:#fff;text-decoration:none}.ElW4b{display:inline-block;margin:1px 0 0;width:20px;height:20px;vertical-align:middle;float:left;fill:currentColor}", ""]);

// exports
exports.locals = {
	"formGroup": "gJnBB",
	"button": "_16pBf",
	"facebook": "wWDRT _16pBf",
	"google": "_1K08m _16pBf",
	"icon": "ElW4b"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/SocialLogin/SocialLogin.css
// module id = 2573
// module chunks = 15